/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for updating a tutorial tag.
 * @export
 * @interface TutorialTagUpdate
 */
export interface TutorialTagUpdate {
    /**
     * 
     * @type {string}
     * @memberof TutorialTagUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialTagUpdate
     */
    description?: string | null;
}

/**
 * Check if a given object implements the TutorialTagUpdate interface.
 */
export function instanceOfTutorialTagUpdate(value: object): value is TutorialTagUpdate {
    return true;
}

export function TutorialTagUpdateFromJSON(json: any): TutorialTagUpdate {
    return TutorialTagUpdateFromJSONTyped(json, false);
}

export function TutorialTagUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialTagUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function TutorialTagUpdateToJSON(json: any): TutorialTagUpdate {
    return TutorialTagUpdateToJSONTyped(json, false);
}

export function TutorialTagUpdateToJSONTyped(value?: TutorialTagUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
    };
}

